// source: design/src/pages/WMSPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_zh';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-wms.jpg',
  heroTitle: '仓储管理系统 (WMS)',
  heroTagline: '智能仓储管理，高效物流运营',
  intro: [
    'WMS（Warehouse Management System，仓储管理系统）是专门用于优化仓储作业的信息系统，覆盖从入库、库内管理到出库的全流程。',
    '现代WMS系统通过条码/RFID技术实现库存实时可视化，结合波次规划、库位优化等智能算法，显著提升仓储作业效率与库存准确率。',
    '飞狼为企业提供WMS系统规划、实施与集成服务，支持与ERP、MES、AGV等系统的无缝对接。',
  ],
  modules: [
    {
      icon: 'si/si-icons/arrow-left-right.svg',
      title: '出入库管理',
      desc: '整合入库与出库全流程，涵盖收货预约、质检上架、发货复核、装车配载、运输交接，支持PDA移动端操作，确保准确及时收发。',
    },
    {
      icon: 'si/si-icons/shopping-basket.svg',
      title: '拣货管理',
      desc: '支持按单拣货、批量拣货、波次拣货、分区拣货等多种策略，优化拣货路径。',
    },
    {
      icon: 'si/si-icons/clipboard-check.svg',
      title: '库存盘点',
      desc: '动态盘点、周期盘点、差异分析，库存准确率达99.5%以上。',
    },
    {
      icon: 'si/si-icons/qr-code.svg',
      title: '条码/RFID',
      desc: '一维码/二维码/RFID多模式支持，实现全程无纸化作业。',
    },
    {
      icon: 'si/si-icons/bar-chart-3.svg',
      title: '报表与KPI',
      desc: '库存周转、出入库效率、订单履约率等关键指标实时监控。',
    },
    {
      icon: 'si/si-icons/layers-3.svg',
      title: '立体仓库',
      desc: '支持自动化立体仓库(AS/RS)系统集成，实现高密度存储、自动存取、与堆垛机/穿梭车的协同调度。',
    },
  ],
  scenarios: [
    {
      icon: 'si/si-icons/shopping-cart.svg',
      title: '电商物流',
      desc: '支持大促峰值订单处理、多渠道库存共享、快速退换货处理，日处理能力可达10万单以上。',
    },
    {
      icon: 'si/si-icons/factory.svg',
      title: '制造业',
      desc: '原材料仓与成品仓一体化管理，支持生产领料、成品入库的MES联动。',
    },
    {
      icon: 'si/si-icons/store.svg',
      title: '零售配送',
      desc: '门店补货、越库作业、配送路径优化，配送准时率达98%以上。',
    },
    {
      icon: 'si/si-icons/thermometer.svg',
      title: '医药冷链',
      desc: '温湿度监控、批号效期管理、GSP合规，保障药品质量安全。',
    },
  ],
  agvTitle: 'WMS与AGV/机器人仓储的协同',
  agvTitleEn: 'Coordination between WMS and AGV/robotic warehousing',
  agvSteps: [
    {
      step: '01',
      title: 'WMS任务下发',
      desc: 'WMS根据订单生成拣货/搬运任务',
    },
    {
      step: '02',
      title: 'AGV调度执行',
      desc: 'AGV控制系统接收任务，自动规划最优路径',
    },
    {
      step: '03',
      title: '实时状态反馈',
      desc: 'AGV完成任务后自动回传WMS更新库存',
    },
  ],
  agvArchitecture: '系统集成架构',
  agvWms: 'WMS',
  agvWmsLabel: '仓储管理系统',
  agvController: 'AGV Controller',
  agvControllerLabel: 'AGV调度系统',
  agvFleet: 'Robot Fleet',
  agvFleetLabel: '机器人集群',
  benefits: [
    {
      number: '99.5%',
      title: '库存准确率',
      desc: '条码/RFID全程追踪，实时库存可视化',
    },
    {
      number: '30-50%',
      title: '拣货效率提升',
      desc: '智能波次规划与路径优化，减少行走距离',
    },
    {
      number: '20%',
      title: '空间利用率提升',
      desc: '智能库位分配与动态库位优化',
    },
    {
      number: '40%',
      title: '订单履约时间缩短',
      desc: '自动化作业流程，减少人工等待时间',
    },
  ],
};
